module.exports = __webpack_public_path__ + "static/media/na.a74960d9.svg";